import { USER_URL, apiURL } from "../paths";
import { RequestId } from "../types/id";

export const ROLE_URL = `${USER_URL}role/`;
export const getRoleURL = (id: RequestId) => apiURL(`${ROLE_URL}${id}/`);
